import { status, StatusType } from '../../typeStatus'

export const SET_CARACTERISTICAS_PRODUCT_SELECT = 'SET_CARACTERISTICAS_PRODUCT_SELECT'
export const RESET_CARACTERISTICAS_PRODUCT_SELECT = 'RESET_CARACTERISTICAS_PRODUCT_SELECT'
export const GET_PRODUCTS_ECOMMERCE = 'GET_PRODUCTS_ECOMMERCE'
export const GET_PRODUCTS_ECOMMERCE_SUCCEEDED = 'GET_PRODUCTS_ECOMMERCE_SUCCEEDED'
export const GET_PRODUCTS_ECOMMERCE_ERROR = 'GET_PRODUCTS_ECOMMERCE_ERROR'
export const GET_CARACTERISTICAS = 'GET_CARACTERISTICAS'
export const GET_CARACTERISTICAS_SUCCEEDED = 'GET_CARACTERISTICAS_SUCCEEDED'
export const GET_CARACTERISTICAS_ERROR = 'GET_CARACTERISTICAS_ERROR'
export const SET_IS_PRICE_FINAL = ' SET_IS_PRICE_FINAL_BY_CURRENT_COUNTRY'
export const GET_PRODUCTOS_CARACTERISTICAS = 'GET_PRODUCTOS_CARACTERISTICAS'
export const GET_PRODUCTOS_CARACTERISTICAS_SUCCESS = 'GET_PRODUCTOS_CARACTERISTICAS_SUCCESS'
export const GET_PRODUCTOS_CARACTERISTICAS_ERROR = 'GET_PRODUCTOS_CARACTERISTICAS_FAILURE'

export interface FiltroCaracteristicas {
  paisId: number
  siteId?: string
  slug?: string
  productoId?: number
}

export interface FilterCaracteristicas {
  urlParams: {
    productId: number
    countryId: number
  }
  queryParams: {
    ecommerce_enabled?: number
    publication_enabled?: number
    origin: string | null
  }
  label: string
}
export enum SectionFilterProducts {
  HOME = 'home',
  ECOMMERCE = 'ecom',
  DASHBOARD = 'dash',
}
export interface FilterProductos {
  section?: SectionFilterProducts
  finalPrice?: number
  excludedProducts?: number[]
}

export const InitialState: CompraOnlineState = {
  caracteristicasProductSelect: null,
  productsEcommerce: null,
  isPriceFinalByCurrentCountry: null,
  statusProductsEcommerce: status.initial,
  caracteristicas: [],
  caracteristicasStatus: status.initial,
  productosCaracteristicas: [],
  productosCaracteristicasStatus: status.initial,
}

export interface CompraOnlineState {
  caracteristicasProductSelect: string[] | null
  productsEcommerce: Product[] | null
  isPriceFinalByCurrentCountry: boolean | null
  statusProductsEcommerce: StatusType
  caracteristicas: Caracteristicas[]
  caracteristicasStatus: StatusType
  productosCaracteristicas: CaracteristicaProducto[]
  productosCaracteristicasStatus: StatusType
}

export interface CaracteristicaAviso {
  characteristic: string
  includes: number
}

export interface CaracteristicaProducto {
  productoId: number
  descripcion: string
  checked: boolean
  zona: string
  order: number
}
export interface Caracteristicas {
  caracteristicasProducto: CaracteristicaAviso[] | null
  caracteristicasProductoLanding: string[] | null
  producto: string | null
}

export interface SetCaracteristicasProductSelect {
  type: typeof SET_CARACTERISTICAS_PRODUCT_SELECT
  payload: string[]
}

export interface SetCaracteristicasProductSelectReset {
  type: typeof RESET_CARACTERISTICAS_PRODUCT_SELECT
  payload: null
}

export interface Product {
  productos: ProductPart[]
  final: boolean
  siteId: string
}

interface ProductPart {
  id: string
  parts: Part[]
}

interface Part {
  codigoProducto: string
  tipoProducto: string
  precio: number
  caracteristicas: string[]
  descripcion: string
  slug?: string
  creditosInicial?: number
  codigoEcom: number
}

export interface GetProductsEcommerce {
  type: typeof GET_PRODUCTS_ECOMMERCE
  payload: null
}
export interface GetProductsEcommerceSucceeded {
  type: typeof GET_PRODUCTS_ECOMMERCE_SUCCEEDED
  payload: Product[]
}
export interface GetProductsEcommerceError {
  type: typeof GET_PRODUCTS_ECOMMERCE_ERROR
  payload: boolean
}

export interface GetCaracteristicas {
  type: typeof GET_CARACTERISTICAS
  payload: []
}
export interface GetCaracteristicasSucceeded {
  type: typeof GET_CARACTERISTICAS_SUCCEEDED
  payload: Caracteristicas
}
export interface GetCaracteristicasError {
  type: typeof GET_CARACTERISTICAS_ERROR
  payload: boolean
}

export interface GetProductosCaracteristicas {
  type: typeof GET_PRODUCTOS_CARACTERISTICAS
  payload: []
}
export interface GetProductosCaracteristicasSucceeded {
  type: typeof GET_PRODUCTOS_CARACTERISTICAS_SUCCESS
  payload: CaracteristicaProducto[]
}
export interface GetProductosCaracteristicasError {
  type: typeof GET_PRODUCTOS_CARACTERISTICAS_ERROR
  payload: boolean
}

export interface SetIsPriceFinalByCurrentCountry {
  type: typeof SET_IS_PRICE_FINAL
  payload: boolean | null
}

export type CompraOnlineActions =
  | SetCaracteristicasProductSelect
  | SetCaracteristicasProductSelectReset
  | GetProductsEcommerce
  | GetProductsEcommerceSucceeded
  | GetProductsEcommerceError
  | GetCaracteristicas
  | GetCaracteristicasSucceeded
  | GetCaracteristicasError
  | SetIsPriceFinalByCurrentCountry
  | GetProductosCaracteristicas
  | GetProductosCaracteristicasSucceeded
  | GetProductosCaracteristicasError
